import React, {useState} from 'react';
import '../Folderer/Folderer.scss';
import { closeFoldererView } from '../noteslice';
import { changeAdminPdfView, setPdfFileName} from '../../../Admin/adminSlice';
import pdfIconFile from '../../../../styles/svg_notes/pdf-file.svg';
import { formatDate } from '../../../../helper/formatData';

const Folderer = (props) => {

    const [selectedFiles, setSelectedFiles] = useState([]); 

    const {dispatch} = props;
    
    const iconFile = pdfIconFile;


//ON CLICK CLOSE
        const onClickClose = () => {
            dispatch(closeFoldererView());

        }
 
    //HANDLE VIEW PDF 
    const handleClickPdfViewer  = (e) => {

        const data = {
            
            pdfName: e.target.value,
        };
      
        dispatch(setPdfFileName(data.pdfName));
        dispatch(changeAdminPdfView());
    }



  //RENDER FILES TABLE
      const  renderFilesTable = () => {
        //let  data =  [{titles:'example.pdf',size:1234, data:"12/3/25"},{titles:'first01.pdf',size:124, data:"12/3/25"}];
        const data = props.noteAddFiles;

        return (
            data.map((item, index) => {
                console.log(item);
                return(
                    <div className='tr'  key={index}>
                        
                        <img  src={iconFile} alt="icon" className="iconFile"/><p className='titles'>{item.filename}</p>
                        <p className='size'>{(item.filesize/1048576).toFixed(1)}МБ</p>
                        <p className='data'>{formatDate(item.data)}</p>
                        <p ><button className='btnFavorites' onClick={handleClickPdfViewer} value={item.filename}>view</button></p>
                        <p ><button className='btnFavorites'>download</button></p>
                    </div>
                    )
                })
            )    
       }




    return (
        <div className='Folderer'>
            
                <div className="return-menu">
                       <button className="exit" onClick={onClickClose}></button>
                </div>
                                
                
                    <p className='titleFolder'>{props.selectedIdNote}/</p>
                     <div className='table'>
                            <div className='thead'>
                                <div className='tr tr-head'>
                                    
                                    <p className='th titles'>Наименование</p>                            
                                    <p className='th size'>Размер</p>
                                    <p className='th data'>Дата</p>
                                   
                                </div>
                                
                            </div>
                            <div className='tbody'>
                            
                                {renderFilesTable()}
                            
                            </div>
                    
                
            </div>
           
           
        </div>
    )




    
    
}
export default Folderer;